var Vue = require('vue');
var v = new Vue();
var Comm = require("./Common.js");
/**
 * @param method 方法仅限以下方法query, create, save, delete
 * @param resourceName 资源的路径，如['department'], 对于嵌套的资源与key相对应如: department/1/employee    
 * @param param.key 与资源对应，resourceName.length - 1 <= key.length <= resourceName.length 
 * @param param.data 上传的数据
 * @param param.succ 成功后的回调
 * @param param.err 失败后的回调
 **/
var paramParse = function(method, resourceName, param) {
    var resource = {
        method: 'GET',
        url: ''
    };
    param.key = param.key||[];
    switch (method) {
        case 'query':
            resource.method = 'GET';
            break;
        case 'create':
            resource.method = 'POST';
            break;
        case 'save':
            resource.method = 'PUT';
            break;
        case 'delete':
            resource.method = 'DELETE';
            break;
        default:
            console.log('error method' + method);
    };

    if (param.key.length < resourceName.length - 1 || param.key.length > resourceName.length) {
        console.log('资源与参数不匹配');
        return false;
    }

    for (var i = 0; i < resourceName.length; i++) {
        resource.url += '/' + resourceName[i];
        if (param.key[i]) {
            resource.url += '/' + param.key[i];
        }
    }
    /*----本地测试使用 start -----*/
    // resource.method = 'GET';
    // console.log("url:" + resource.url);
    // resource.url = 'src/json/' + resourceName[0] + '/' + method  + '.json';
    // console.log("url:" + resource.url);
    /*----本地测试使用 end-----*/

    if (param.data) {
        resource.data = param.data;
    }

     v.$http(resource).then(function(response) {
        var rs = response.data;
        if (rs.status == 200) {
            if(param.succ){
                param.succ(rs['data']);
            }
        } else if(rs.status == 300){//登录过期
            Comm.rmTipDialog();
            Comm.confirm("登录已过期,请重新登录",function() {
               Comm.setCookie(-100000);//设置cookie过期
            });             
        } else {
            if (param.err) {
                param.err(rs.msg);
            }
        }
    }, function(response) {
        if (param.err) {
            if(response.statusText != "") {               
                param.err(response.statusText);
            } else {
                Comm.tipDialog("网络错误,请重试!",1500,"error");
            }
        } 
    });
};
module.exports = {
    /**
    * 管理公司
    */
    company : {
        query: function(param) {
            paramParse('query', ['company'], param);
        },
        create: function(param) {
            paramParse('create', ['company'], param);
        },
        save: function(param) {
            paramParse('save', ['company'], param);
        },
        list : function(param){            
            paramParse('query', ['companylist'], param);
        }
    },
    /**
    * 门店
    */
    shop : {
        query: function(param) {
            paramParse('query', ['shop'], param);
        },
        create: function(param) {
            paramParse('create', ['shop'], param);
        },
        save: function(param) {
            paramParse('save', ['shop'], param);
        },
        delete: function(param) {
            paramParse('delete', ['shop','status'], param);
        },
        createStatus: function(param) {
            paramParse('create', ['shop', 'status'], param);
        },
        queryOne : function(param){            
            paramParse('query', ['shopname'], param);
        },
        list : function(param){            
            paramParse('query', ['shoplist'], param);
        },
        /**
        * 上移
        */
        up : function(param){
            paramParse('create', ['shopup'], param);
        },
        /**
        * 下移
        */
        down : function(param){
            paramParse('create', ['shopdown'], param);
        }   
    },
    /**
    * 技师列表
    */
    mechanic : {
        query: function(param) {
            paramParse('query', ['mechanic'], param);
        },
        create: function(param) {
            paramParse('create', ['mechanic'], param);
        },
        save: function(param) {
            paramParse('save', ['mechanic'], param);
        },
        delete: function(param) {
            paramParse('delete', ['mechanic','status'], param);
        },
        createStatus: function(param) {
            paramParse('create', ['mechanic', 'status'], param);
        },
        /**
        * 上移
        */
        up : function(param){
            paramParse('create', ['mechanicup'], param);
        },
        /**
        * 下移
        */
        down : function(param){
            paramParse('create', ['mechanicdown'], param);
        } 
    },
    /**
    * 区域地址
    */
    area : {
         query: function(param) {
            paramParse('query', ['area'], param);
        }
    },
    /**
    * 文章
    */
    article : {
        query: function(param) {
            paramParse('query', ['article'], param);
        },
        create: function(param) {
            paramParse('create', ['article'], param);
        },
        save: function(param) {
            paramParse('save', ['article'], param);
        },
        createStatus: function(param) {
            paramParse('create', ['article','status'], param);
        },
        deleteStatus: function(param) {
            paramParse('delete', ['article','status'], param);
        },
    },
    login : {
        create : function(param){            
            paramParse('create', ['auth/login'], param);
        }
    },
    logout : {
        create : function(param){            
            paramParse('create', ['auth/logout'], param);
        }
    },
    articlecategory:{
        query : function(param){            
            paramParse('query', ['articlecategory'], param);
        }
    },
    //验证码获取
    smscode: {
        create : function(param){            
            paramParse('create', ['auth/smscode'], param);
        }
    },
    //验证码重置登录密码
    smsforget: {
        create : function(param){            
            paramParse('create', ['auth/smsforget'], param);
        }
    },
    //账户信息
    account: {
        query : function(param){            
            paramParse('query', ['account'], param);
        }
    },
    //BD统计功能
    shopInfo: {
        query: function(param){
            paramParse('query', ['shopInfo'], param);
        }
    },
    //导出
    export: {
        query: function(param){
            paramParse('query', ['export'], param);
        }
    },
    //管理公司续费
    renewal: {
        create: function(param){
            paramParse('create',['renewal'], param);
        }
    },
    //改变管理公司状态
    statusChange:{
        create:function(param){
            paramParse('create',['companyStatusChange'],param);
        }
    }
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/HttpHelper.js
 ** module id = 29
 ** module chunks = 0
 **/